import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { InfoIcon } from '../../../../components/info-icon';

const CustomCell = ({ field, row }) => {
	if (field === 'id') {
		return (
			<div className="custom-cell__id">
				<InfoIcon popupContent={`№ ${row[field]}`} link={row.link} />
			</div>
		);
	}

	if (field === 'group_id' && row.group && row.group.id !== 1) {
		return (
			<Link className="custom-cell__link" to={row.group.link}>
				{row.group.name}
			</Link>
		);
	}

	if (field === 'way_id' && row.way) {
		return (
			<Link className="custom-cell__link" to={row.way.link}>
				{row.way.id}
			</Link>
		);
	}

	if (field === 'req_id' && row.req) {
		return (
			<Link className="custom-cell__link" to={row.req.link}>
				{row.req.id}
			</Link>
		);
	}

	if (field === 'address_from' && row.address_from) {
		return (
			<Link className="custom-cell__link" to={row.address_from.link}>
				{row.address_from.address}
			</Link>
		);
	}

	if (field === 'address_to' && row.address_to) {
		return (
			<Link className="custom-cell__link" to={row.address_to.link}>
				{row.address_to.address}
			</Link>
		);
	}

	return row[field];
};

CustomCell.propTypes = {
	row: PropTypes.object.isRequired,
	field: PropTypes.string.isRequired,
};

export { CustomCell };
